import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import EmptyData from 'components/EmptyData';

import { IStudentGradesModel } from '@common/models/StudentGrades/StudentGrades';

import GradeGridListItem from './Item';
import * as Styled from './styled';

type PropsType = {
	studentGrades: IStudentGradesModel;
	programsIds: number[];
};

function GradeGrid({ studentGrades, programsIds }: PropsType) {
	const { t } = useTranslation();

	if (!programsIds.length) {
		return (
			<EmptyData
				title={t('gradeBook.selectProgramTitle')}
				subTitle={t('gradeBook.selectProgramDescription')}
			/>
		);
	}

	if (Array.from(studentGrades.data).length < 1) {
		return (
			<EmptyData
				title={t('gradeBook.noGradesTitle')}
				subTitle={t('gradeBook.noGradesDescription')}
			/>
		);
	}

	return (
		<Styled.List>
			{Object.entries(studentGrades.sortedGradesByProgram).map(([date, programs], index) => (
				<Fragment key={date}>
					{Object.entries(programs).map(([programId, grades]) => (
						<GradeGridListItem
							index={index}
							key={`${date}-${programId}`}
							date={date}
							grades={grades}
						/>
					))}
				</Fragment>
			))}
		</Styled.List>
	);
}

export default GradeGrid;
